import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import swal from "sweetalert";
import LogoutFunction from "../services/LogoutFunction";

export const FetchCourses = createAsyncThunk(
  "course/getAll",
  async (pageNumber) => {
    const tokenData = await JSON.parse(localStorage.getItem("userData")).token;
    console.log(process.env.REACT_APP_VERSEL_API);
  const request = await fetch(
    `${process.env.REACT_APP_VERSEL_API}/api/users/courses/getAll/?page=${pageNumber}`,
    {
      method: "GET",
      headers:{
        "Authorization" : `Bearer ${tokenData}`
      }
    }
  )
    .then((response) => response.json())
    .then((result) => {
      return result;
    })
    .catch((error) => {
        console.log(error);
      formatError(error);
    });

  return request;
});

function formatError(errorResponse) {
  swal("Oops", `${errorResponse}`, "error");
}

const getAllCourses = createSlice({
  name: "getCouses",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  extraReducers: (builder) => {
    builder.addCase(FetchCourses.pending, (state) => {
      state.loading = true;
      state.data = null;
      state.error = null;
    });
    builder.addCase(FetchCourses.fulfilled, (state, action) => {
      if (action.payload.message === "jwt expired") {
        state.error = action.payload.message;
        formatError(state.error);
        LogoutFunction();
      }
     else  if (action.payload.message === "fetched successfully") {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      } else {
        state.loading = false;
        state.data = null;
        state.error = action.payload.message;
        formatError(state.error);
      }
    });
    builder.addCase(FetchCourses.rejected, (state, action) => {
      state.loading = false;
      state.data = null;
      state.error = action.payload.message;
      formatError(state.error);
    });

  },
});

export default getAllCourses.reducer;

